import { useState } from 'react'
import { NavContainer, OuterCircle, InnerCircle, Logo, ContentCircle } from './styles/NavPage.styled'
import { NavIcons } from './NavPageIcons'
import { LogoImg } from './styles/NavPage.styled'


const NavPage = () => {
  const [id, setId] = useState('')

  const onHover1 = () => { 
    setId('lpg') 
  }
  const onHover2 = () => { 
    setId('market') 
  }
  const onHover3 = () => { 
    setId('plants') 
  }
  const onHover4 = () => { 
    setId('trucking') 
  }
  const onHover5 = () => { 
    setId('refinery') 
  }
  const onHover6 = () => { 
    setId('producers') 
  }
  const onHover7 = () => { 
    setId('shipping') 
  }
  const onHover8 = () => { 
    setId('boat') 
  }
  const onHover9 = () => { 
    setId('pricing') 
  }
  const onHover10 = () => { 
    setId('hseq') 
  }

  const onLeave = () => {
    setId('')
  }

  return (
   <NavContainer>
    <OuterCircle>
      <InnerCircle>
        <Logo>
          <LogoImg />
        </Logo>
        <NavIcons  onHover1={onHover1} onHover2={onHover2} 
        onHover3={onHover3}  onHover4={onHover4} onHover5={onHover5} onHover6={onHover6} 
        onHover7={onHover7} onHover8={onHover8} onHover9={onHover9} onHover10={onHover10}
        onLeave={onLeave}/>
      </InnerCircle>
      <ContentCircle id={id} >
        <div>
        <h4>LPG NEWS</h4>
        <p>Current and Past on LPG Industry, social media feed and industry developments.</p>
        </div>
        <div>
        <h4>MARKETS</h4>
        <p>
        Market Volume by LGA, State Region etc Presented by Cylinder Type and bulk</p>
        </div>
        <div>
        <h4>PLANTS</h4>
        <p>Spot whole sale and retail pricing by plants; Nation wide plant information, Location and capacity.</p>
        </div>
        <div>
        <h4>TRUCKING</h4>
        <p>Product Movement by Truck, LPG Logistics cost calculator LPG truck population and truck type.</p>
        </div>
        <div>
        <h4>REFINERY</h4>
        <p>Refinery Operational status and loading activity</p>
        </div>
        <div>
        <h4>PRODUCER</h4>
        <p>Production center information by inland and coastal - specifically gas processing plants.</p>
        </div>
        <div>
        <h4>SHIPPING</h4>
        <p>Cargo by Cargo information: Ship call port and jetty information.</p>
        </div>
        <div>
        <h4>TERMINALS</h4>
        <p>Information on Terminals: Location capacity, operational activity and inventory.</p>
        </div>
        <div>
        <h4>LPG PRICING</h4>
        <p>HGranular market supply and demand pricing information. Demand side presented by wholesale and retail and GPS,LGA,State and Region etc.</p>
        </div>
        <div>
        <h4>HSEQ</h4>
        <p>Health, safety , Environmental and Quality information across Nigeria. Detailed quarterly product quality test results.</p>
        </div>
        </ContentCircle>
    </OuterCircle>
   </NavContainer> 
  )
} 

export default NavPage


